import { render, staticRenderFns } from "./reset-password-verify-email.vue?vue&type=template&id=7cfc9e80&"
import script from "./reset-password-verify-email.vue?vue&type=script&lang=js&"
export * from "./reset-password-verify-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports